import {BaseEntity} from "../../entities/BaseEntity";
import {NotificationService} from "../../services/NotificationService";
import { StateService } from "@uirouter/angularjs";
import { ServerImportModel } from "../../models/serverimport/ServerImportModel";

export class ServerImportConfirmCtrl<T extends BaseEntity>{
    public static $inject = ['$scope','$state','ImportModel','NotificationService'];
    currentPage:number = 1;
    working:boolean = false;
    constructor(public $scope: any, public stateService: StateService, public model: ServerImportModel<T>, public notifyService:NotificationService) {
        this.$scope.vm = this;
        this.$scope.$watch(() => this.currentPage,(newValue: string, oldValue: string) => {
            if(newValue != oldValue) {

            }
        });
    }
    previous():void{
        this.stateService.go(this.model.getRoute("mapfields"));
    }
    next(): void {
        this.working = true;
        this.model.startImport(false).then((ok) => {
            this.working = false;
            if (ok) {
                if (this.model.errors.length == 0) {
                    this.stateService.go(this.model.getRoute("summary"));
                }
                else {
                    this.stateService.go(this.model.getRoute("fixerrors"));
                }
            }
        }).catch((exc) => {
            this.notifyService.notifyError("Got error in testing import:" + exc);
            this.working = false;
        })
    }
}
